export default __webpack_public_path__ + "static/media/outside2.4a105bdb.webp";